<template>
  <div class="pos el-form-item">
    <div class="itemm">
      <div class="label" v-if="config.label">{{ config.label }}：</div>
      <el-select v-model="value" :placeholder="config.placeholder || '请选择'" @change="$change" @focus="$focus"
        @blur="$blur" filterable :multiple="config.multiple" :class="config.className"
        :collapse-tags="config.collapseTags" :clearable="config.clearable">
        <el-option v-for="(n, i) in options" :key="n.label + i" :label="n.label" :value="n.value" :disabled="n.disabled">
        </el-option>
      </el-select>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    options: Array,
    config: Object,
    inputValue: Array,
  },
  data() {
    return {
      value: this.inputValue,
      keyName: this.config.keyName,
      placeholder: this.config.placeholder || this.config.err,
    };
  },
  watch: {
    inputValue: {
      deep: true,
      handler(newVal) {
        // console.log(`input '${this.keyName}' value is '${newVal}'`);
        this.value = newVal;
      },
    },
  },
  methods: {
    $change(v) {
      // console.log(this.keyName, v, typeof v);
      this.$emit("onChange", {
        key: this.keyName,
        value: v,
      });
    },
    $focus() {
      this.$emit("onFocus", {
        key: this.keyName,
      });
    },
    $blur() {
      // console.log('blur')
      this.$emit("onBlur", {
        key: this.keyName,
        value: this.value,
      });
    },
  },
};
</script>

<style lang="less" scoped>
// .pos {
//   width: 10px;
//   height: 40px;
//   position: relative;
// }
.itemm {
  display: flex;
  align-items: center;
  // top: -70px;
  // right: 0px;
  // position: absolute;

  .label {
    min-width: 70px;
  }

  /deep/ .el-select {
    width: 205px;

    .el-input {
      width: 100%;
    }
  }
}
</style>
